// import * as Vue from "vue";
import { createStore } from "vuex";
import api from "@/api/axios";
// let $api = new api({});
export default createStore({
  state: {
    user_token: localStorage.getItem("user_token") || "",
    tab_list: [],
    category_list: []
  },
  mutations: {
    login(state, token) {
      state.user_token = token;
      localStorage.setItem("user_token", token);
    },
    loginOut(state) {
      state.user_token = "";
      localStorage.removeItem("user_token");
      // $api.get({
      //   url: "user/out",
      //   success: (res) => {}
      // });
    },
    setTabList(state, list) {
      state.tab_list = list;
    },
    setCategoryList(state, list) {
      // console.log(list);
      state.category_list = list;
      localStorage.setItem("category_list", JSON.stringify(list));
    }
  },
  actions: {},
  modules: {}
});
